import apiSlice from "./apiSlice";

const keyClearancesDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getClearanceKpi: builder.query({
            query: (projectId) => ({
                url: `clearance/kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ClearanceKpi"],
        }),

        getDueThisMonth: builder.query({
            query: ({ projectId, page = 1, pageSize = 5 }) => ({
                url: `clearance/due-this-month`,
                params: { projectId, page, pageSize },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["DueThisMonth"],
        }),

        getPendingByAuthority: builder.query({
            query: ({projectId}) => ({
                url: `clearance/kpi/pending-by-authority`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["PendingByAuthority"],
        }),

        getDelayAnalysis: builder.query({
            query: ({projectId}) => ({
                url: `clearance/kpi/delay-analysis`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["DelayAnalysis"],
        }),
    }),
});

export const {
    useGetClearanceKpiQuery,
    useGetDueThisMonthQuery,
    useGetPendingByAuthorityQuery,
    useGetDelayAnalysisQuery,
} = keyClearancesDashboardApiSlice;
